export default __webpack_public_path__ + "static/ecology-82430a14d535225c744f13e8836333be.png";